import { ICoreContext } from '@msdyn365-commerce/core';
import { useSyncGenderCookie } from '../../../shared/services/gender-cookie-service/hooks/use-sync-gender-cookie';
import { getHomepageGender } from '../../../shared/services/gender-cookie-service/gender-cookie-service';

export interface IUseGenderHeaderOptions {
    context: ICoreContext;
}

/**
 * Synchronizes the gender cookie from gendered homepage URLs.
 */
export const useGenderHeader = (options: IUseGenderHeaderOptions): void => {
    const { context } = options;
    useSyncGenderCookie(getHomepageGender(context), context);
};
